import React, {useState} from 'react';
import './App.css';
import {v5 as uuidv5} from 'uuid';

function App() {
    const [key, setKey] = useState("");
    const [uuid, setUUID] = useState("e129f27c-5103-5c5c-844b-cdf0a15e160d");
    const computeUUID = (key: string) => {
        const len = key.length;
        if (len > 30) return;
        setKey(key)
        setUUID(uuidv5(key, "00000000-0000-0000-0000-000000000000"))
    }
    return (
        <div className="App">
            <h2>Xray UUID Generator</h2>
            <div><label>Key: <input size={30} value={key} minLength={1} maxLength={30}
                                    onChange={(event) => computeUUID(event.target.value)}/></label></div>
            <div><label>UUID: <input size={36} minLength={36} maxLength={36} value={uuid}/></label></div>
        </div>
    );
}

export default App;
